// projects/humanresources-personnel/src/assets/i18n/*/hr-per-subtype-school.json
export class HrPerSubtypeSchoolKey {
    private static readonly keyPrefix = 'hrPerSubTypeSchool';
    public static title = `${HrPerSubtypeSchoolKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerSubtypeSchoolKey.keyPrefix}.pageHeader`;
    public static educationGroupCode = `${HrPerSubtypeSchoolKey.keyPrefix}.educationGroupCode`;
    public static instFacultyBranchCode = `${HrPerSubtypeSchoolKey.keyPrefix}.instFacultyBranchCode`;
    public static typeEduSubtypeCode = `${HrPerSubtypeSchoolKey.keyPrefix}.typeEduSubtypeCode`;
}
